export enum PixelEventName {
  PageView = 'PageView',
  Scroll25 = 'Scroll25',
  Scroll50 = 'Scroll50',
  Scroll75 = 'Scroll75',
  SocialClickFacebook = 'SocialClickFacebook',
  SocialClickLinkedIn = 'SocialClickLinkedIn',
  EmailClick = 'EmailClick',
  PhoneClick = 'PhoneClick',
  ApplicationCta = 'ApplicationCta',
  RequestCta = 'RequestCta',
  AuctionsContactFormSubmit = 'AuctionsContactFormSubmit',
  ParkingContactFormSubmit = 'ParkingContactFormSubmit',
  CarouselSwipe = 'CarouselSwipe',
  CarouselOfferSelected = 'CarouselOfferSelected',
  CarouselOfferDetails = 'CarouselOfferDetails',
  SpecialOfferFormSubmit = 'SpecialOfferFormSubmit',
  PhoneBanner = 'PhoneBanner',
}


export interface PageViewPayload {
  url: string;
}

export interface ScrollPayload {
  percentage: 25 | 50 | 75;
}

export interface SocialClickPayload {
  platform: 'facebook' | 'linkedin';
}

export interface EmailClickPayload {
  email: string;
}

export interface PhoneClickPayload {
  phone: string;
}

export interface ApplicationCtaClickPayload {
  page?: string;
}

export interface RequestCtaClickPayload {
  page?: string;
}

export interface ContactFormSubmitPayload {
  status: FormSubmitStatus;
}

export interface CarouselSwipePayload {
  page: number | undefined;
}

export interface CarouselOfferSelectedPayload {
  offerId: string;
}

export interface SpecialOfferFormSubmitPayload {
  offerId: string;
  status: FormSubmitStatus;
}

export interface PhoneBannerPayload {
  event: AvailablePhoneBannerEvent
}

export interface PixelEventPayloadMap {
  [PixelEventName.PageView]: PageViewPayload;
  [PixelEventName.Scroll25]: ScrollPayload;
  [PixelEventName.Scroll50]: ScrollPayload;
  [PixelEventName.Scroll75]: ScrollPayload;
  [PixelEventName.SocialClickFacebook]: SocialClickPayload;
  [PixelEventName.SocialClickLinkedIn]: SocialClickPayload;
  [PixelEventName.EmailClick]: EmailClickPayload;
  [PixelEventName.PhoneClick]: PhoneClickPayload;
  [PixelEventName.ApplicationCta]: ApplicationCtaClickPayload;
  [PixelEventName.RequestCta]: RequestCtaClickPayload;
  [PixelEventName.AuctionsContactFormSubmit]: ContactFormSubmitPayload;
  [PixelEventName.ParkingContactFormSubmit]: ContactFormSubmitPayload;
  [PixelEventName.CarouselSwipe]: CarouselSwipePayload;
  [PixelEventName.CarouselOfferSelected]: CarouselOfferSelectedPayload;
  [PixelEventName.CarouselOfferDetails]: CarouselOfferSelectedPayload;
  [PixelEventName.SpecialOfferFormSubmit]: SpecialOfferFormSubmitPayload;
  [PixelEventName.PhoneBanner]: PhoneBannerPayload;
}

export type PixelEvent<E extends PixelEventName = PixelEventName> = {
  name: E;
  data: PixelEventPayloadMap[E];
};

export type ScrollEvent = (ScrollPayload & { event: PixelEventName });
export type SocialClickEvent = (SocialClickPayload & { event: PixelEventName });

export enum FormSubmitStatus {
  SUCCESS = 'success',
  ERROR = 'error'
}

export enum AvailablePhoneBannerEvent {
  SHOW = 'show',
  CLOSE = 'close',
  CLICK = 'click',
  REJECT = 'reject',
}
